import { render, staticRenderFns } from "./PhoneNumberField.vue?vue&type=template&id=00aabb83&scoped=true&"
import script from "./PhoneNumberField.vue?vue&type=script&lang=ts&"
export * from "./PhoneNumberField.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneNumberField.vue?vue&type=style&index=0&id=00aabb83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aabb83",
  null
  
)

export default component.exports